/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Trouble_Old_Pc_QInputs */

const en_wc_dl_trouble_old_pc_q = /** @type {(inputs: Wc_Dl_Trouble_Old_Pc_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows: slow on an older PC`)
};

/**
* | output |
* | --- |
* | "Windows: slow on an older PC" |
*
* @param {Wc_Dl_Trouble_Old_Pc_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_trouble_old_pc_q = /** @type {((inputs?: Wc_Dl_Trouble_Old_Pc_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Trouble_Old_Pc_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_trouble_old_pc_q(inputs)
});
export { wc_dl_trouble_old_pc_q as "wc.dl.trouble.old_pc.q" }